<template>
  <nav class="nav">
    <div class="nav-container">
      <router-link to="/" class="nav-brand">
        <img src="@/assets/SCCLogoNoText-1536x1536.png" alt="SC Logo" class="nav-logo" />
        <span class="brand-text">Social Conscience</span>
      </router-link>

      <div class="nav-menu">
        <div class="nav-item dropdown">
          <router-link to="/about" class="nav-link">About</router-link>
          <div class="dropdown-menu">
            <router-link to="/about#engineering">Engineering</router-link>
            <router-link to="/about#community">Community Projects</router-link>
          </div>
        </div>

        <router-link to="/borrow" class="nav-link">Borrow</router-link>

        <div class="nav-item dropdown">
          <router-link to="/engineering" class="nav-link">Engineering</router-link>
          <div class="dropdown-menu">
            <router-link to="/engineering#who-we-serve">Who We Serve</router-link>
          </div>
        </div>

        <router-link to="/login" class="nav-link">Login</router-link>
        <router-link to="/register" class="btn btn-primary nav-cta">Get Started</router-link>
      </div>

      <button class="mobile-toggle" @click="mobileMenuOpen = !mobileMenuOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{ open: mobileMenuOpen }">
      <router-link to="/about" class="mobile-link" @click="mobileMenuOpen = false">About</router-link>
      <router-link to="/borrow" class="mobile-link" @click="mobileMenuOpen = false">Borrow</router-link>
      <router-link to="/engineering" class="mobile-link" @click="mobileMenuOpen = false">Engineering</router-link>
      <router-link to="/login" class="mobile-link" @click="mobileMenuOpen = false">Login</router-link>
      <router-link to="/register" class="mobile-link cta" @click="mobileMenuOpen = false">Get Started</router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      mobileMenuOpen: false
    };
  }
};
</script>

<style scoped>
.nav {
  padding: 0;
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  height: 85px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: hsl(0, 0%, 20%);
}

.nav-logo {
  height: 60px;
  width: auto;
}

.brand-text {
  font-size: 26px;
  font-weight: 700;
}

.nav-menu {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-item {
  position: relative;
}

.nav-link {
  padding: 12px 18px;
  color: hsl(0, 0%, 20%);
  text-decoration: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 6px;
  transition: background 0.2s;
}

.nav-link:hover {
  background: hsl(0, 0%, 96%);
}

.nav-cta {
  margin-left: 12px;
  padding: 12px 28px;
  font-size: 16px;
}

/* Dropdown */
.dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 8px 0;
  min-width: 200px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  z-index: 50;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu a {
  display: block;
  padding: 10px 16px;
  color: hsl(0, 0%, 20%);
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s;
}

.dropdown-menu a:hover {
  background: hsl(0, 0%, 96%);
}

/* Mobile Toggle */
.mobile-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
}

.mobile-toggle span {
  width: 24px;
  height: 2px;
  background: hsl(0, 0%, 20%);
  transition: all 0.2s;
}

/* Mobile Menu */
.mobile-menu {
  display: none;
  flex-direction: column;
  padding: 16px 24px;
  border-top: 1px solid #eee;
}

.mobile-menu.open {
  display: flex;
}

.mobile-link {
  padding: 12px 0;
  color: hsl(0, 0%, 20%);
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid #eee;
}

.mobile-link.cta {
  margin-top: 16px;
  padding: 14px;
  background: hsl(155, 100%, 22%);
  color: #fff;
  text-align: center;
  border-radius: 9999px;
  border: none;
}

/* Responsive */
@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }

  .mobile-toggle {
    display: flex;
  }
}
</style>
